<template>
  <div class="pdf-container">
        <!-- <iframe :src="`/static/pdfjs-2.4.456-dist/web/viewer.html?file=${encodeURIComponent(src)}`"></iframe> -->
    <iframe :src="`/static/pdfjs-2.4.456-dist/web/viewer.html?file=${encodeURIComponent(src)}`"></iframe>
  </div>
</template>

<script>
export default {
  data() {
    return {
      src: ""
    };
  },
  mounted() {
    // 这里是请求分片的接口，看情况修改
    this.src = `https://static.vbidding.com/x-file/trade/2026/6/08/851840261729296384/3af773164af78326cebe1a56c0ef3024.pdf?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=hbxc%2F20260611%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20260611T022158Z&X-Amz-Expires=18000&X-Amz-SignedHeaders=host&X-Amz-Signature=86298538bcf1a988834d5a7693ec28b0596dfc999ff6b0096ae1d5a9e78872e6`;
  }
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.pdf-container {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
}

iframe {
  width: 100%;
  height: 100%;
  border: none;
}
</style>
